import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogSMSIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogSMS",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M7.51 10.88V8.61h2.27c.61 0 1.05-.52 1.05-1.05s-.44-1.05-1.05-1.05H7.51V4.15c0-.52-.53-1.05-1.05-1.05s-1.14.52-1.14 1.05v2.27H3.05C2.53 6.42 2 6.95 2 7.56s.52 1.05 1.05 1.05h2.27v2.27c0 .61.44 1.05 1.05 1.05s1.14-.44 1.14-1.05m20.04-3.94H16.61c-1.31 0-2.36 1.05-2.36 2.36v2.36h7.09c2.19 0 3.94 1.75 3.94 3.94v2.36h2.36c1.31 0 2.36-1.05 2.36-2.36V9.3c-.09-1.31-1.14-2.36-2.45-2.36m-6.3 6.3H8.83c-1.31 0-2.36 1.05-2.36 2.36v12.51c0 .35.17.61.44.7.09 0 .17.09.26.09.17 0 .44-.09.52-.26l4.46-4.46h9.1c1.31 0 2.36-1.05 2.36-2.36v-6.21c0-1.31-1.05-2.36-2.36-2.36Zm-.7 7.79H9.53c-.44 0-.79-.35-.79-.79s.35-.79.79-.79h10.94c.44 0 .79.35.79.79s-.35.79-.7.79Zm0-3.06H9.53c-.44 0-.79-.35-.79-.79s.35-.79.79-.79h10.94c.44 0 .79.35.79.79s-.35.79-.7.79Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.43 21.43c-.63 0-1.14-.51-1.14-1.14V10c0-.63-.51-1.14-1.14-1.14h-9.14a1.14 1.14 0 1 1 0-2.28h9.14c1.89 0 3.43 1.54 3.43 3.43V20.3c0 .63-.51 1.14-1.14 1.14ZM7.71 14.57c-.63 0-1.14-.51-1.14-1.14V2a1.14 1.14 0 1 1 2.28 0v11.43c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.43 8.86H2a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28M4.29 30.57c-.15 0-.3-.03-.44-.09-.43-.18-.71-.59-.71-1.06V16.85a1.14 1.14 0 1 1 2.28 0v9.81l2.62-2.62c.21-.21.5-.33.81-.33h13.71c.63 0 1.14-.51 1.14-1.14v-8c0-.63-.51-1.14-1.14-1.14h-4.57a1.14 1.14 0 1 1 0-2.28h4.57c1.89 0 3.43 1.54 3.43 3.43v8c0 1.89-1.54 3.43-3.43 3.43H9.32l-4.24 4.24c-.22.22-.51.33-.81.33Z"
      })]
    })
  }));
};
LogSMSIcon.displayName = 'LogSMSIcon';